export const answerItemTemplate = ({ answer, answerIndex, error }) => {
  const hasError = error && error.name

  return `
    <li class="form-group" data-answer-index="${answerIndex}">
      <div class="flex items-center gap-10 2md:pr-180">
        <input type="text"
          class="grow form-input form-input--2sm"
          value="${answer.name || ""}"
          placeholder="Enter your answer"
          data-question-target="answerInput"
          data-action="input->question#updateAnswer"
          data-answer-index="${answerIndex}">
        <button type="button" class="p-4"
          data-action="click->question#removeAnswer"
          data-answer-index="${answerIndex}">
          <i class="icon-xmark text-flameorange text-10"></i>
        </button>
      </div>
      <span class="${hasError ? 'error' : 'hidden'}">
        ${hasError ? error.name : ''}
      </span>
    </li>
  `
}

export const answersContainerTemplate = (answers, errors = {}, question = {}) => {
  const answerItems = answers.map((answer, answerIndex) => {
    const error = errors[answer.id]
    return answerItemTemplate({ answer, answerIndex, error })
  }).join("")

  return `
    <div class="content-section-md">
      <div class="font-medium">Answers</div>

      <ul class="content-section-sm" data-question-target="answersContainer">
        ${answerItems}
      </ul>

      <div class="flex flex-col"
        data-controller="answer-csv-upload"
        data-answer-csv-upload-question-id-value="${question.id || ''}">
        <div class="flex items-center gap-10">
          <button type="button"
            class="self-start btn-transparent-sm w-fit text-16! font-medium!"
            data-action="click->question#addAnswer">
            <i class="icon-plus text-18"></i>
            <span>Add answer</span>
          </button>

          <div>
            <input type="file"
                  accept=".csv"
                  class="hidden"
                  data-answer-csv-upload-target="fileInput">
            <button type="button"
              class="self-start btn-transparent-sm w-fit text-16! font-medium!"
              data-action="click->answer-csv-upload#triggerFileInput"
              data-answer-csv-upload-target="uploadButton">
              <i class="icon-plus text-18"></i>
              <span>Upload CSV list of answers</span>
            </button>
          </div>
        </div>

        <div class="hidden text-limegreen mt-10 text-14" data-answer-csv-upload-target="successMessage"></div>
        <div class="hidden text-chilired mt-10 text-14" data-answer-csv-upload-target="errorMessage"></div>
      </div>
    </div>
  `
}
